import React, { useEffect, useState } from 'react';
import { func } from 'prop-types';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import Dialog from '../../common/Dialog';
import '../../prescription-2/DrugDosageDescription/DosageSelectionMobileNew/index.scss';
import './index.scss';
import { fetchDrugStructure } from '../../../services/Api/SaveCoupon/SaveCouponService';
import DropDownSelection from './dropdownSelection';
import Loader from '../../common/Loader';

const DrugDropdownModal = ({
  editDrugData,
  setIsEditCouponDrug,
  handleEditSuccess,
  drugData,
  setDrugItems
}) => {
  const initialIds = {
    brandId: 0,
    dosageId: 0,
    formId: 0,
    quantityId: 0
  };

  const [drugStructureData, setDrugStructureData] = useState();
  const [selectedIds, setSelectedIds] = useState(initialIds);
  const [customQuantity, setCustomQuantity] = useState();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const { i18n } = useTranslation();

  const updateDropdowns = async drugstructure => {
    // get brand id
    let findObj = {
      brand: editDrugData.drugName
    };
    if (Object.prototype.hasOwnProperty.call(editDrugData, 'drugType')) {
      findObj.drugType = editDrugData.drugType;
    }
    const id = _.findConsolidatedBrandIndex(drugstructure.brandTypes, findObj);
    // get form id
    const newFormId = _.findConsolidatedFormIndex(
      drugstructure?.brandTypes[id]?.formTypes,
      editDrugData?.form?.toLowerCase()
    );
    // get dosage id
    const newDosageId = _.findConsolidatedDosageIndex(
      drugstructure.brandTypes[id].formTypes[newFormId].dosage,
      editDrugData.dosage
    );

    // get quantity id

    let newQuantityId = _.CheckCustomQuantityIndex(
      drugstructure.brandTypes[id].formTypes[newFormId].dosage[newDosageId]
        .quantities,
      editDrugData.displayQuantity
    );
    const isCustomQtyValid = _.checkIfCustomQtyVisible(
      drugstructure.brandTypes[id].formTypes[newFormId].name
    );
    if (newQuantityId === -1) {
      if (isCustomQtyValid) {
        setCustomQuantity(String(editDrugData.displayQuantity));
      }
      newQuantityId = 0;
    } else {
      setCustomQuantity('');
    }
    const newState = {
      ...selectedIds,
      ...{
        brandId: id,
        formId: newFormId,
        dosageId: newDosageId,
        quantityId: newQuantityId
      }
    };
    setSelectedIds(newState);
  };

  const getDrugStructure = async () => {
    const locale = _.isEqual(i18n.language, 'es') ? 'es-US' : 'en-US';
    const drugStructureResponse = await fetchDrugStructure(
      editDrugData.seoName,
      locale
    );
    if (drugStructureResponse) {
      setDrugStructureData(drugStructureResponse);
      updateDropdowns(drugStructureResponse);
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getDrugStructure();
  }, []);

  return (
    <div className="homepage-new editDrugsModal">
      <div
        className="transparentBg"
        onClick={() => {
          setDrugItems(drugData);
          setIsEditCouponDrug(false);
        }}
      ></div>
      <Dialog
        className="modalContent"
        escKeyFunction={() => {
          setDrugItems(drugData);
          setIsEditCouponDrug(false);
        }}
      >
        <div className="modalSection">
          <div className="modal-header">
            <div className="modal-header--text">Edit your prescription</div>
            <button
              className="sc-icon-close"
              onClick={() => {
                setDrugItems(drugData);
                setIsEditCouponDrug(false);
              }}
              role="link"
              title=""
              aria-hidden="true"
            ></button>
          </div>
          {isLoading ? (
            <div className="modalLoader">
              <Loader />
            </div>
          ) : (
            drugStructureData &&
            drugStructureData.drug && (
              <DropDownSelection
                brandTypes={drugStructureData.brandTypes}
                defaultKeys={drugStructureData.defaultKey}
                defaultStructure={drugStructureData.drug}
                drugIds={selectedIds}
                handleEditSuccess={handleEditSuccess}
                customQuantity={customQuantity}
              />
            )
          )}
        </div>
      </Dialog>
    </div>
  );
};

DrugDropdownModal.propTypes = {
  setSaveDrugModal: func
};

DrugDropdownModal.defaultProps = {
  setSaveDrugModal: () => {}
};

export default DrugDropdownModal;
